import { productCardId } from '../../data/productsCatalogData'

function getCardDescription(item) {
  if (item.description) return item.description
  return `High-quality ${item.name} for industrial, commercial and manufacturing applications.`
}

function ProductsCatalogSection({ section }) {
  const { label, title, description, items, id } = section

  return (
    <section className="products-catalog-block" id={id}>
      <div className="container corp-container">
        <div className="products-catalog-block__panel">
          <header className="products-catalog-block__header">
            <span className="section-label section-label--gold products-catalog-block__label">
              {label}
            </span>
            <h2 className="products-catalog-block__title">{title}</h2>
            <p className="products-catalog-block__desc">{description}</p>    
          </header>

          <div className="products-catalog-block__grid products-premium-grid" role="list">
            {items.map((item) => (
              <article
                className="products-premium-card"
                id={productCardId(item.name)}
                key={item.name}
                role="listitem"
              >
                <div className="products-premium-card__media">
                  <img src={item.image} alt={item.name} loading="lazy" />
                </div>
                <div className="products-premium-card__body">
                  <h3>{item.name}</h3>
                  <p>{getCardDescription(item)}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsCatalogSection
